import React from "react";
import { useRoutes } from "react-router-dom";

/* Components Pages */
import BranchComponent from "./pages/components/branch/branchComponent";
import ApiCall from "./pages/components/branch/apiCall";
import SendMessage from "./pages/components/branch/sendMessage";

import OutBound from "./pages/components/outbound/outBound";
import InBound from "./pages/components/inbound/inBound";
import InboundAnalyze from "./pages/components/inboundanalyze/inBoundAnalyze";

/* Admin Pages */
import PrivateRoute from "./pages/admin/PrivateRoute";
import LoginMasterLayout from "./pages/admin/layout/LoginMasterLayout";
import Login from "./pages/admin/pages/login";

import DashboardLayout from "./pages/admin/layout/DashboardLayout";
import Dashboard from "./pages/admin/pages/dashboard";
import PossibleResponseGroup from "./pages/admin/pages/PossibleResponseGroup";
import Configuration from "./pages/admin/pages/configuration";
import MetaDataGroup from "./pages/admin/pages/metaDataGroup";
import WorkFlowComponent from "./pages/components/workflowcomponent/workFlowComponent";
import WorkFlow from "./pages/components/workflowcomponent/workflow";
import DemoComp from "./pages/components/branch/demoComp";
import UploadWorkflow from "./pages/components/uploadWorkflow/uploadWorkflow";
import WorkFlowManagement from "./pages/admin/pages/WorkFlowManagement";
import PatientView from "./pages/admin/pages/PatientView";
import WorkflowManage from "./pages/admin/pages/workflowManage";
import WorkflowEditor from "./pages/admin/pages/DynamicFlowManage";
import ConversationLog from "./pages/admin/pages/conversationLog";

export default function App() {
  const isAuth = true;

  // Dynamically import components
  const componentContext = require.context("./pages/components", true, /index\.js$/);
  const components = {};

  componentContext.keys().forEach((filePath) => {
    const folders = filePath.split("/"); // Get folder structure
    const componentName = folders[folders.length - 2]; // Extract folder name
    components[componentName] = componentContext(filePath).default;
  });

  const routes = [
    // Workflow Components Routes
    { path: "/branchcomponent", element: <BranchComponent /> },
    { path: "/apiCall", element: <ApiCall /> },
    { path: "/sendMessage", element: <SendMessage /> },
    { path: "/inBound", element: <InBound /> },
    { path: "/outBound", element: <OutBound /> },
    { path: "/inBoundAnalyze", element: <InboundAnalyze /> },
    { path: "/demoComp", element: <DemoComp /> },

    // Admin Routes
    { path: "/", element: <LoginMasterLayout><Login /></LoginMasterLayout> },
    {
      path: "/dashboard",
      element: (
        <PrivateRoute isAuth={isAuth}>
          <DashboardLayout><Dashboard /></DashboardLayout>
        </PrivateRoute>
      ),
    },
    {
      path: "/PossibleResponseGroup",
      element: (
        <PrivateRoute isAuth={isAuth}>
          <DashboardLayout><PossibleResponseGroup /></DashboardLayout>
        </PrivateRoute>
      ),
    },
    {
      path: "/Configuration",
      element: (
        <PrivateRoute isAuth={isAuth}>
          <DashboardLayout><Configuration /></DashboardLayout>
        </PrivateRoute>
      ),
    },
    {
      path: "/MetaDataGroup",
      element: (
        <PrivateRoute isAuth={isAuth}>
          <DashboardLayout><MetaDataGroup /></DashboardLayout>
        </PrivateRoute>
      ),
    },
    {
      path: "/WorkFlowComponent",
      element: (
        <PrivateRoute isAuth={isAuth}>
          <DashboardLayout><WorkFlowComponent /></DashboardLayout>
        </PrivateRoute>
      ),
    },
    {
      path: "/Workflow",
      element: (
        <PrivateRoute isAuth={isAuth}>
          <DashboardLayout><WorkFlow /></DashboardLayout>
        </PrivateRoute>
      ),
    },
    {
      path: "/UploadWorkflow",
      element: (
        <PrivateRoute isAuth={isAuth}>
          <DashboardLayout><UploadWorkflow /></DashboardLayout>
        </PrivateRoute>
      ),
    },
    {
      path: "/WorkFlowManagement",
      element: (
        <PrivateRoute isAuth={isAuth}>
          <DashboardLayout><WorkFlowManagement /></DashboardLayout>
        </PrivateRoute>
      ),
    },
    {
      path: "/PatientView",
      element: (
        <PrivateRoute isAuth={isAuth}>
          <DashboardLayout><PatientView /></DashboardLayout>
        </PrivateRoute>
      ),
    },

    {
      path: "/manageworkflow",
      element: (
        <PrivateRoute isAuth={isAuth}>
          <DashboardLayout><WorkflowManage /></DashboardLayout>
        </PrivateRoute>
      ),
    },
    {
      path: "/dynamicworkflow",
      element: (
        <PrivateRoute isAuth={isAuth}>
          <DashboardLayout><WorkflowEditor /></DashboardLayout>
        </PrivateRoute>
      ),
    },
    {
      path: "/logs",
      element: (
        <PrivateRoute isAuth={isAuth}>
          <DashboardLayout><ConversationLog /></DashboardLayout>
        </PrivateRoute>
      ),
    },

    { path: "*", element: <LoginMasterLayout><Login /></LoginMasterLayout> },
  ];

  // Add dynamically loaded components as routes (if they are not already present)
  Object.keys(components).forEach((key) => {
    const path = `/${key}`;
    if (!routes.some((route) => route.path === path)) {
      routes.push({ path, element: React.createElement(components[key]) });
    }
  });

  const AppRoutes = useRoutes(routes);

  return <>{AppRoutes}</>;
}
